// extracted by css-extract-rspack-plugin
export default {"icon":"icon--e2uxgwYwCyoLEcol","christmasTree":"christmas-tree--w7VwjW20i0nQ4Q6T","setka":"setka--ocM8fIdVCMR2F890"};